module.exports = __webpack_public_path__ + "files/cbeefe2c8adf9c1fe2f921f1454b00f0.png";